// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEbsVolumesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-ebs-volumes_svga)" d="M40 0H0v40h40z" />
    <svg width={23} height={28} x={8.5} y={6} viewBox="0 0 23 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.72 1.27h13.03l2.8 3.74H1.92zM.64 6.28h21.2a.64.64 0 0 0 .5-1.01L18.57.25a.6.6 0 0 0-.5-.25H4.4q-.31.01-.5.25L.13 5.27a.63.63 0 0 0 .5 1.01m.67 20.45H21.2V8.5H1.3zm20.52-19.5H.67a.64.64 0 0 0-.63.65v19.48c0 .36.28.64.63.64h21.16c.36 0 .64-.28.64-.64V7.88a.64.64 0 0 0-.64-.64"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-ebs-volumes_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEbsVolumes",
);
export default AwsEbsVolumesIcon;
